import type { Optional } from 'chaika-frontend-types/frontend-cms';

import type { SignedPdf } from '@patient/services/entry/entryFilesService';
import { ENTRY_FILE_DEFAULT_NAME } from '@store/types';
import { isDefined } from '@utils/isDefined';

import type { SignData } from './SignData';

export async function prepareSignedPdf(pdfData: ArrayBuffer, signData: SignData): Promise<Optional<SignedPdf>> {
    const signature = await signData(pdfData);
    if (!isDefined(signature)) {
        return undefined;
    }

    return {
        file: new File([pdfData], ENTRY_FILE_DEFAULT_NAME, { type: 'application/pdf' }),
        signature: new File([signature], 'entry-signature.sgn', { type: 'plain/text' }),
    };
}
